import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateNewTagComponent } from './create-new-tag.component';
import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '@app/material.module';
import { NgxMatSelectSearchShimModule } from '@app/shims/mat-select-search/ngx-mat-select-search.shim';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgOptionHighlightModule } from '@app/shared/modules/ng-option-highlight.module';
import { FuseCardComponent } from '@fuse/components/card';
@NgModule({
    declarations: [CreateNewTagComponent],
    imports: [
        CommonModule,
        SharedModule,
        TranslateModule.forChild(),

        NgxMatSelectSearchShimModule,

        NgSelectModule,
        NgOptionHighlightModule,

        NgSelectModule,
        FuseCardComponent,
        FuseCardComponent,
        MaterialModule,

    ],
    exports: [CreateNewTagComponent]
})
export class CreateNewTagModule { }
